import { API_URL } from "../config/config";
import { getRequest } from "../utils/axiosUtils";

export const fetchLatestReviewComment = async (type, refId) => {
  try {
    const response = await getRequest({
      url: `${API_URL}/review?type=${type}&refId=${refId}`,
    });
    if (response.status >= 200 && response.status < 300 && response.data?.success) {
      return response.data.data?.comment || response.data.data?.text || '';
    }
    return '';
  } catch (err) {
    return '';
  }
};